import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props

const badgeClass = computed(() => {
  switch (props.status) {
    case 'active':
      return 'badge-success'
    case 'inactive':
      return 'badge-danger'
    case 'pending':
      return 'badge-warning'
    default:
      return 'badge-secondary'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["badge", badgeClass.value])
  }, _toDisplayString(__props.status.charAt(0).toUpperCase() + __props.status.slice(1)), 3))
}
}

})